import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=66c9d645&scoped=true"
import script from "./Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=66c9d645&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c9d645",
  null
  
)

export default component.exports